export default "/fonts/SofiaSans-600-SemiBold.woff2?48edebea38368512b49a16ac9e712664";